import { useQuery } from '@tanstack/react-query';
import { dimensionService } from '../services/dimension.service';
import type { ListRecordsResponse, Dimension } from '../services/dimension.service';

export function useDimensionsList(options?: {
  page?: number;
  pageSize?: number;
  filters?: Record<string, any>;
  enabled?: boolean;
}) {
  const {
    page = 1,
    pageSize = 50,
    filters = {},
    enabled = true,
  } = options || {};

  return useQuery<ListRecordsResponse<Dimension>>({
    queryKey: ['dimensions-list', page, pageSize, filters],
    queryFn: () => dimensionService.find({ page, pageSize, filters }),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useDimensionById(id: string, options?: { enabled?: boolean }) {
  const { enabled = true } = options || {};

  return useQuery<Dimension>({
    queryKey: ['dimension', id],
    queryFn: () => dimensionService.findById(id),
    enabled: enabled && !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
